export enum EEcddStatus {
  draft = 'draft',
  submitted = 'submitted',
  approved = 'approved',
  rejected = 'rejected',
  clientSigned = 'clientSigned',
  autoApproved = 'autoApproved',
  attachmentProcessing = 'attachmentProcessing',
  attachmentError = 'attachmentError',
  rework = 'rework',
}

export enum EEcddType {
  Individual = 'Individual',
  Entity = 'Entity',
  INDIVIDUAL = 'INDIVIDUAL',
  ENTITY = 'ENTITY',
  UCPINDIVIDUAL = 'UCP-INDIVIDUAL',
  UCPENTITY = 'UCP-ENTITY',
}

export enum EEcddTransactionType {
  Sales = 'Sales',
  Rental = 'Rental',
}

export enum EEcddCustomerType {
  tenant = 'tenant',
  landlord = 'landlord',
  seller = 'seller',
  buyer = 'buyer',
}

export enum EEcddIdentityType {
  NRIC = 'NRIC',
  Passport = 'Passport',
  WorkPass = 'Work Pass',
  Others = 'Others',
}
export enum EEcddIdentityType2 {
  NRIC = 'NRIC',
  Passport = 'Passport',
  Other = 'Other',
  WorkPermit = 'WorkPermit',
  FIN = 'FIN',
  UEN = 'UEN',
}

export enum EEcddLegalEntityType {
  LIMITED_PARTNERSHIP = 'LIMITED_PARTNERSHIP',
  LIMITED_LIABILITY_PARTNERSHIP = 'LIMITED_LIABILITY_PARTNERSHIP',
  COMPANY = 'COMPANY',
  TRUST = 'TRUST',
  CORPORATION = 'CORPORATION',
  OTHER = 'OTHER',
}

export enum EEcddResponseType {
  create = 'create',
  edit = 'edit',
  proceedToChecklist = 'proceedToChecklist',
  sendUrlForCustomer = 'sendUrlForCustomer',
  customerSigned = 'customerSigned',
}

export enum EEcddPropertyType {
  HDB = 'HDB',
  CONDO = 'CONDO',
  LANDED = 'LANDED',
  OTHER = 'OTHER',
}

export enum EEcddRepresentType {
  tenant = 'tenant',
  landlord = 'landlord',
  seller = 'seller',
  buyer = 'buyer',
}
export enum EEcddClientType {
  Represented = 'Represented',
  Unrepresented = 'Unrepresented',
}

export enum EEcddActingType {
  Self = 'SELF',
  AnotherIndividual = 'ANOTHER_INDIVIDUAL',
  AnotherCompany = 'ANOTHER_COMPANY',
}

export enum EEcddEntityType {
  LimitedPartnership = 'LimitedPartnership',
  LimitedLiabilityPartnership = 'LimitedLiabilityPartnership',
  Company = 'Company',
  Corporation = 'Corporation',
  Trust = 'Trust',
  others = 'others',
}

export enum EEcdd2TransactionType {
  RESALE = 'RESALE',
  PROJECTSALE = 'PROJECT',
}
export enum EEcddGender {
  M = 'M',
  F = 'F',
  U = 'U',
}

export enum EEcddResidentialStatus {
  A = 'A',
  C = 'C',
  P = 'P',
  U = 'U',
  N = 'N',
  F = 'F',
}


export enum EEcddFormStatus {
  PENDING_APPROVAL = 'PENDING_APPROVAL',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED'
}


export enum EEcddApprovedType {
  APPROVED = 'APPROVED',
  NOT_APPROVED = 'NOT_APPROVED',
}

export enum EEcddRecommendedType {
  RECOMMENDED = 'RECOMMENDED',
  NOT_RECOMMENDED = 'NOT_RECOMMENDED',
}
export enum EEcddFormCAndU6FileNameType {
  BANK_STATEMENTS = 'BankStatements',
  CPF_STATEMENT = 'CpfStatement',
  SALE_PURCHASE_AGREEMENT_PREVIOUS_PROPERTY = 'SalePurchaseAgreementPreviousProperty',
  LOAN_APPROVAL_LETTER = 'LoanApprovalLetter',
  INVESTMENT_PORTFOLIO_STATEMENTS = 'InvestmentPortfolioStatements',
  GIFT_DEED_INHERITANCE_DOCUMENTS = 'GiftDeedInheritanceDocuments',
  OTHERS_CHECKBOX_2 = 'OthersCheckbox2',
  COMPANY_FINANCIAL_STATEMENTS = 'CompanyFinancialStatements',
  EMPLOYMENT_LETTER_PAY_SLIPS = 'EmploymentLetterPaySlips',
  TAX_RETURNS = 'TaxReturns',
  INVESTMENT_CERTIFICATES = 'InvestmentCertificates',
  PROPERTY_OWNERSHIP_DOCUMENTS = 'PropertyOwnershipDocuments',
  OTHERS_CHECKBOX_4 = 'OthersCheckbox4',
}

export enum EEcddAttachmentDocType {
  A1 = 'A1',
  B = 'B',
  C = 'C',
  U1 = 'U1',
  U5 = 'U5',
  U6 = 'U6',
  DOC_U1 = 'DOC-U1',
  DOC_ID = 'doc-id',
  DOC_A1 = 'DOC-A1',
  SIGNATURE = 'signature',
  LETTER = 'letter',
  SUPPORT_DOCUMENTS = 'support-documents',
  ACRA_CERTIFICATE = 'acra-certificate',
  AML_REPORT = 'amlReport',
}

export enum EEcddFormType {
  A1 = 'A1',
  A2 = 'A2',
  A3 = 'A3',
  A4 = 'A4',
  B = 'B',
  U1 = 'U1',
  U2 = 'U2',
  U3 = 'U3',
  U4 = 'U4',
  U5 = 'U5',
  U6 = 'U6',
}

export enum ECDDManagementOwnershipType {
  PD = 'PD',
  BO = 'BO',
}


export enum EEcddVersionType {
  ECDD = 'ecdd',
  ECDD_HIP = 'ecdd_hip',
  DCDD = 'dcdd',
}


export enum EDCDDActionAuditType {
  REGENERATE_ATTACHMENTS = 'regenerateAttachments',
  GET_THE_SIGNATURE_LINK = 'getTheSignatureLink',
}
